import {
  FETCH_QUIZ_REQUEST,
  RECEIVE_QUIZ,
  RECEIVE_QUIZ_ERROR,
} from 'redux/constants/ActionTypes'

import { createApiAction } from './ApiActions'

// API actions
export const fetchQuiz = ({
  currentLocale,
  currentProject,
  quizPath,
  branch,
}) => {
  const endpoint = `/${currentLocale}/projects/${currentProject}/quizzes/${quizPath}${
    branch ? `?branch=${branch}` : ''
  }`
  return createApiAction({
    endpoint,
    types: [FETCH_QUIZ_REQUEST, RECEIVE_QUIZ, RECEIVE_QUIZ_ERROR],
    currentLocale,
    currentProject,
    quizPath,
  })
}
